
import React, { useState } from 'react';

import useFilterForCheckbox from '../hooks/useFilterForCheckbox';

import FilterItem from './FilterItem';

/**
 * ThemeFilter
 *
 * A filter that returns selected themes
 *
 * @param {Object} props
 * @param {Object} props.context
 * @param {Object} props.setStart
 * @param {string} props.dataCode
 * @param {Object} props.scrollToTop
 */
const ThemeFilter = ({ data, setStart, dataCode, scrollToTop }) => {
  const [ isActive, setIsActive ] = useState( false );

  const {
    checked,
    setChecked,
    handleFilter
  } = useFilterForCheckbox( setStart, dataCode, scrollToTop );

  const themes = data.map( ( theme ) => {
    return {
      label: theme.title.rendered,
      value: theme.ACF.theme_codes
    };
  });

  return (
    themes.length > 0 && (
      <FilterItem
        data={ themes }
        setStart={ setStart }
        dataCode="data-theme-codes"
        title="Theme"
        isActive={ isActive }
        setIsActive={ setIsActive }
        checked={ checked }
        setChecked={ setChecked }
        handleFilter={ ( e, index ) => handleFilter( e, index ) }
        scrollToTop={ scrollToTop }
      />
    )

  );
};

export default ThemeFilter;
